import {Section} from "./Section";
import {Order} from "../Order";
import {CartSection} from "./Cart";
import {ShippingSection} from "./Shipping";

export class ConfirmSection extends Section {

  constructor(sectionElement) {
    super(sectionElement);

    this.nextSectionButton = this.element.querySelector('[data-button="next"]');
    ConfirmSection.element = this.element;
    ConfirmSection.confirmField = ConfirmSection.element.querySelector('[id="confirm"]');
  }

  static update() {
    const CONFIRM_DATA = Order.confirmData

    const ADDRESS_LISTING_ELEMENT = ConfirmSection.element.querySelector('[data-confirm="address-listing"]');
    Section.updateAddressSection(CONFIRM_DATA.address, ADDRESS_LISTING_ELEMENT);

    const SHIPPING_LISTING_ELEMENT = ConfirmSection.element.querySelector('[data-confirm="shipping-listing"]');
    Section.updateShippingSection(ShippingSection, CONFIRM_DATA.shipping, SHIPPING_LISTING_ELEMENT)

    const PRODUCTS_ARRAY = Array.from(Order.products);
    const PRODUCT_LISTING_ELEMENT = ConfirmSection.element.querySelector('[data-confirm="cart-listing"] .products');
    ConfirmSection.updateProducts(PRODUCTS_ARRAY, PRODUCT_LISTING_ELEMENT);

    const DISCOUNT_LISTING_ELEMENT = ConfirmSection.element.querySelector('[data-confirm="cart-listing"] .discounts');
    ConfirmSection.updateDiscounts(CartSection, DISCOUNT_LISTING_ELEMENT);

    const SHIPPING_COST_ELEMENT = ConfirmSection.element.querySelector('[data-confirm="shipping-price"]');
    ConfirmSection.updateShippingCosts(ShippingSection, CONFIRM_DATA.shipping, SHIPPING_COST_ELEMENT);

    const RETOURE_COST_ELEMENT = ConfirmSection.element.querySelector('[data-confirm="retoure-price"]');
    ConfirmSection.updateRetoureCost(ShippingSection, RETOURE_COST_ELEMENT);

    const TOTAL_PRICE_ELEMENT = ConfirmSection.element.querySelector('[data-confirm="total-price"]');
    ConfirmSection.updatePriceTotal(CartSection, ShippingSection, TOTAL_PRICE_ELEMENT);
  }
}

export const INSTANTIATE_CONFIRM_SECTION = () => {
  const CONFIRM_SECTION_ELEMENT = document.querySelector('[data-section="confirm"]');
  if (!CONFIRM_SECTION_ELEMENT) return;

  return  new ConfirmSection(CONFIRM_SECTION_ELEMENT);
}
